import React, { useState } from 'react';
import { Row, Col, Button } from 'antd';
import { handlers } from '../../helpers/helpers';
import { initializeSurveyExam } from '../../services/testPage';

const TestDetail = ({ test, testsLength, allTests, setStep, refreshTestName, refreshTimer, userData, group, refreshInitialTimeStamp }) => {
  const [testDetail, setTestDetail] = useState(
    JSON.parse(localStorage.getItem('userData')).isTestDetail ? JSON.parse(localStorage.getItem('userData')).isTestDetail : false,
  );

  const currentDateTime = new Date();
  const currentMilisecondsTime = Date.parse(currentDateTime);

  const showTestDetail = () => {
    setTestDetail(true);
    handlers.handleUserData({ isTestDetail: true });
  };

  const goToGroupDetail = async () => {
    let isMounted = true;
    const checkIfInitialTestTime = userData.initialTestTime;
    const getInitialTime = currentDateTime.toLocaleTimeString('es-CL');

    if (['created', 'reevaluate'].includes(group.admission_patient_exam_state)) {
      try {
        await initializeSurveyExam({ admissionPatientExamId: group.admission_patient_exam });
        if (isMounted) handlers.markSurveysAsInitialized(group);
      } catch (error) {
        if (isMounted) console.error('Error initializing exam from device:', error);
      }
    }

    if (!checkIfInitialTestTime) {
      handlers.handleUserData({
        initialTestTime: getInitialTime,
        currentTestName: test.name,
        isTimerOn: true,
      });
    } else {
      handlers.handleUserData({
        currentTestName: test.name,
        isTimerOn: true,
      });
    }

    refreshTimer();
    refreshTestName();
    if (isMounted) setStep(2);

    return () => {
      isMounted = false;
    };
  };

  return (
    <Row justify="center" className="test-detail-container mt-80">
      {test && !testDetail ? (
        <Col lg={22} md={22}>
          <Row justify="center">
            <Col md={24}>
              <h1>Evaluaciones de psicología</h1>
              <h3 className="mb-30">
                Tienes que realizar <strong>{testsLength}</strong> {testsLength > 1 ? 'evaluaciones:' : 'evaluación:'}
              </h3>
            </Col>
            <Col md={24} className="test-detail-list">
              <ul>
                {allTests.map((test) => {
                  return (
                    <li key={test.id} className="mb-20">
                      {test.name}
                    </li>
                  );
                })}
              </ul>
            </Col>
            {/* <Col md={24}>
                <h4 className="mt-30">Tiempo total estimado de resolución: <strong>{testsLength * 60 } minutos</strong></h4>
              </Col> */}
            <Col md={24} className="text-gray-wrapper p-30 mt-30">
              <p className="mb-0 text-center">Lea con atención cada pantalla, el sistema lo guiará para resolver las evaluaciones.</p>
            </Col>
            <Col md={24} className="mt-150 mb-40">
              <Row justify="end">
                <Col md={5}>
                  <Button onClick={showTestDetail} type="primary" size="large" block>
                    Continuar
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      ) : (
        <Col lg={22} md={22}>
          <Row justify="center">
            <Col md={24} className="mt-20">
              <h1 className="text-center">{test.name}</h1>
            </Col>
            <Col md={24} className="test-description-wrapper p-30 mt-30">
              <p dangerouslySetInnerHTML={{ __html: test.description }} />
            </Col>
            <Col md={24} className="mt-50 mb-30">
              <Row justify="center">
                <Col md={10}>
                  <Button onClick={() => goToGroupDetail(test.name)} type="primary" size="large" block>
                    Comenzar evaluación
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default TestDetail;
